import render from './render'

export default {
  name: 'TreesListReadonly',

  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    }
  },

  data() {
    return {
      search: undefined
    }
  },

  computed: {
    values() {
      if (Array.isArray(this.value) && this.value.length) {
        return this.value.filter(value => {
          if (this.search) {
            const search = `${this.search}`.toLowerCase()
            const values = [ value ].map(item => {
              return `${item}`.toLowerCase()
            })

            return !!~values.findIndex(element => {
              return element.includes(search)
            })
          }

          return true
        })
      }

      return []
    }
  },

  render
}
